module.exports = __webpack_public_path__ + "static/media/bg_tab.f8bc5ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/bg_tab.png
// module id = 210
// module chunks = 0